import React, { ComponentProps, FC, useCallback, useContext, useMemo } from 'react';
import { PersonalDataText } from '../../../../../form.common/components';
import { Button, Icon } from '@sravni/react-design-system';
import { ArrowRight } from '@sravni/react-icons';
import cn from 'classnames';
import { useLoggedIn } from '../../../../../../store/reducers/user';
import { StepContext } from '../../../../creator/step.context';
import { useFormContext } from 'react-hook-form';
import styles from './styles.module.scss';
import { FORM_FIELDS } from '../../../../../../constants';
import { AuthSmsContext } from '../../../../creator/auth.context';
import { getSignInParams } from '../helpers';
import { useSelection } from '../../../../../../store/reducers/selection';

type Props = ComponentProps<'div'> & {};
export const SubmitView: FC<Props> = (props) => {
    const { className } = props;
    const { page } = useSelection();
    const loggedIn = useLoggedIn();
    const { nextStep } = useContext(StepContext);
    const { requestCode, inProcess, setShowingSmsField, showSmsField } = useContext(AuthSmsContext);

    const form = useFormContext();

    const {
        watch,
        setValue,
        formState: { dirtyFields: _, errors },
        trigger,
    } = form;

    const [phone] = watch([FORM_FIELDS.PHONE]);

    const sendSms = useCallback(async () => {
        const params = getSignInParams(phone, page);
        await requestCode(params);
    }, [requestCode, phone, page]);

    const onClick: React.MouseEventHandler<HTMLButtonElement> = useCallback(
        async (event) => {
            const isValid = await trigger();
            if (!isValid) {
                event.preventDefault();
            }

            if (!loggedIn && isValid) {
                event.preventDefault();
                setValue(FORM_FIELDS.SMS_CODE, '');
                await sendSms();
                setShowingSmsField(true);
            }
        },
        [nextStep, trigger, loggedIn, setValue, sendSms, setShowingSmsField],
    );

    const stringifiedErrors = Object.keys(errors).join(' ');

    const isDisabled = useMemo(() => {
        return (!loggedIn && showSmsField) || Object.keys(errors).length > 0;
    }, [loggedIn, stringifiedErrors, showSmsField]);

    return (
        <div className={cn(styles['submit-row'], className)}>
            {!loggedIn && !showSmsField ? (
                <PersonalDataText className={styles['submit-row__text']} btnText="Далее" />
            ) : (
                <div />
            )}
            <Button
                type="submit"
                variant="primary"
                size={52}
                className={styles['submit-row__btn']}
                disabled={isDisabled}
                loading={inProcess}
                onClick={onClick}>
                Далее
                <Icon icon={<ArrowRight />} strong />
            </Button>
        </div>
    );
};
